import { createUseStyles } from "react-jss";
import { COLORS } from "./defaults";

export const containersStyles = {
    stack: {
        display: "flex",
        width: "100%"
    },
    card: {
        display: "flex",
        padding: "0.5em",
        borderRadius: "0.5em",
        backgroundColor: "ghostwhite",
        flexDirection: "column",
    },
    cardOption: {
        backgroundColor: "ghostwhite",
        padding: "1em",
        borderRadius: "1em",
        cursor: "pointer",

        "&:hover": {
            color: COLORS.primary.main,
            boxShadow: "rgba(0, 0, 0, 0.3) 0px 19px 38px, rgba(0, 0, 0, 0.22) 0px 15px 12px"
        }
    },
    margin1em: {
        margin: "1em"
    },
    marginTB1em: {
        marginTop: "1em",
        marginBottom: "1em"
    },
    cardShadow: {
        boxShadow: "rgba(50, 50, 93, 0.25) 0px 2px 5px -1px, rgba(0, 0, 0, 0.3) 0px 1px 3px -1px;"
    },
    listItem: {
        display: "flex",
        padding: "1em 0",
        cursor: "pointer",
        alignItems: "center",
        justifyContent: "space-around",
        borderBottom: "1px solid rgba(0, 0, 0, 0.3)",
        "&:hover": {
            color: COLORS.primary.main,
            backgroundColor: "ghostwhite"
        },
    },
    listItemAwards: {
        display: "flex",
        padding: "1em 0",
        cursor: "pointer",
        alignItems: "center",
        justifyContent: "space-around",
        // "&:hover": {
        //     color: COLORS.primary.main,
        //     // backgroundColor: "ghostwhite"
        // },
    },
    listTransactions: {
        display: "flex",
        padding: "1em 0",
        cursor: "pointer",
        alignItems: "left",
        justifyContent: "space-around",
        borderBottom: "1px solid rgba(0, 0, 0, 0.3)",
        "&:hover": {
            color: COLORS.primary.main,
            backgroundColor: "ghostwhite"
        },
    },
    selectedItem: {
        color: COLORS.primary.main,
        backgroundColor: "ghostwhite"
    },
    glowingCircularBadge: {
        width: "10em",
        height: "10em",
        padding: "1.5em",
        borderRadius: "50%"
    },
    width10: { width: "10%" },
    width15: { width: "15%" },
    width20: { width: "20%" },
    width60: { width: "60%" },
    width70: { width: "70%" },
    width80: { width: "80%" },
    width100: { width: "100%" },
    error: { color: "#be123c" },
    maxWidth30: { maxWidth: "30%" },
    fontSmall: { fontSize: "0.8em" },
    marginTB05em: { margin: "0.5em 0" },
};
export const containerClasses = createUseStyles(containersStyles);